"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.default = (function (contentId, fieldName, contentTypeId, displayText) {
    if (!contentId && !displayText)
        return null;
    var getDisplayVal = function () {
        if (displayText)
            return displayText;
        if (fieldName)
            return lodash_1.startCase(fieldName);
        if (contentTypeId)
            return lodash_1.startCase(contentTypeId);
        return 'Item';
    };
    var displayVal = getDisplayVal();
    return lodash_1.pickBy({
        'data-csk-entry-id': contentId,
        'data-csk-entry-field': fieldName,
        'data-csk-entry-type': contentTypeId,
        'data-csk-entry-display-text': displayVal
    }, lodash_1.identity);
});
